export default __webpack_public_path__ + "formThanksImage.png";